var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOnIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7222 18.75H36.8056V16.6667H34.7222V18.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8056 20.8333H38.8889V18.75H36.8056V20.8333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8056 31.25H38.8889V29.1667H36.8056V31.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7222 33.3333H36.8056V31.25H34.7222V33.3333Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5556 22.9167H32.6389V20.8333H30.5556V22.9167Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5556 29.1667H32.6389V27.0833H30.5556V29.1667Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9722 20.8333H38.8889V29.1667H40.9722V20.8333Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7222 22.9167H32.6389V27.0833H34.7222V22.9167Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1389 35.4167V37.5H24.3056V35.4167H20.1389Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9722 33.3333V35.4167H20.1389V33.3333H15.9722Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8056 31.25V33.3333H15.9722V31.25H11.8056Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8056 18.75H9.72223V31.25H11.8056V18.75Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9722 18.75V16.6667H11.8056V18.75H15.9722Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1389 16.6667V14.5833H15.9722V16.6667H20.1389Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3056 14.5833V12.5H20.1389V14.5833H24.3056Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3056 35.4167H26.3889V14.5833H24.3056V35.4167Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOnIcon);
export default __webpack_public_path__ + "static/media/sound_on_icon.83444a49b3931f04df865574d50befd2.svg";
export { ForwardRef as ReactComponent };